/**
 * Version Converter.
 * For each update there will always be clients who are on the old client for a while. I
 * This converter is if you have breaking changes in the JSON in the client from one version to the other.
 *
 * Say bulkId is renamed to voyageBulkId from v1.39 => v1.40. (of course now you can use the VoyageBulk modal class to handle this change but for the example).
 * You can create a VRC.Version140 with a upgrade method that parses loads the local storage, rename all bulkId to voyageBulkId and saves to localstorage.
 *
 */

var VRC = VRC || {};

VRC.VersionConverter = (function () {

	var isUpgraded = function (json, type) {
		return true; //Now always updated. When it is time to update the model, use this method to detect if you are on a old and not updated.
	};

	var upgrade = function (json, type) {
		return VRC.Version131.upgrade(json, type); //Return the version updater.
	};

	return {
		isUpgraded: isUpgraded,
		upgrade: upgrade
	};
})();
